// Turning whatever someone pastes (an email thread, a chat, a screenshot) into context
// the genie can read, without them having to save it as a file first.

// A line or two is a note; anything longer, or with several lines (an email, a chat),
// is something to read, like a document
const SHORT_PASTE = 200;
export const isShortPaste = (text) =>
  text.length <= SHORT_PASTE && text.split("\n").length <= 3;

// Pasted text becomes a small text file named after how it starts
export function pastedTextFile(text) {
  const start = text
    .trim()
    .split(/\s+/)
    .slice(0, 6)
    .join(" ")
    .replace(/[\\/:*?"<>|]+/g, "")
    .slice(0, 40)
    .trim();
  return new File([text], `Pasted - ${start || "text"}.txt`, {
    type: "text/plain",
  });
}

function imageName(type, index) {
  const extension = (type.split("/")[1] || "png").replace("jpeg", "jpg");
  return `Pasted picture${index ? ` ${index + 1}` : ""}.${extension}`;
}

// What a paste event carries: pictures (like screenshots) and text
export function readPasteEvent(event) {
  const data = event.clipboardData;
  if (!data) return { files: [], text: "" };
  const files = [...data.files].map((file, index) =>
    file.name && file.name !== "image.png"
      ? file
      : new File([file], imageName(file.type, index), { type: file.type })
  );
  return { files, text: files.length ? "" : data.getData("text/plain") };
}

// Reads the clipboard for the Paste button. Resolves to { files, text }, or null when
// the browser won't allow it (then Ctrl or Cmd + V still works).
export async function readClipboard() {
  try {
    if (navigator.clipboard?.read) {
      const items = await navigator.clipboard.read();
      const files = [];
      let text = "";
      for (const item of items) {
        const picture = item.types.find((type) => type.startsWith("image/"));
        if (picture) {
          const blob = await item.getType(picture);
          files.push(
            new File([blob], imageName(picture, files.length), {
              type: picture,
            })
          );
        } else if (item.types.includes("text/plain")) {
          text += await (await item.getType("text/plain")).text();
        }
      }
      return { files, text };
    }
    if (navigator.clipboard?.readText) {
      return { files: [], text: await navigator.clipboard.readText() };
    }
  } catch {
    // Permission refused or nothing readable
  }
  return null;
}
